"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var ThirdPlace = function () {
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.thirdPlaceContainer },
        react_1.default.createElement("svg", { width: "30", height: "39", viewBox: "0 0 30 39", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginBottom: '-55px' } },
            react_1.default.createElement("path", { d: "M29.0662 39H0.859375V28.6867H17.4637V24.8192H0.859375V14.4544H17.4637V10.5869H0.859375V0.273655H29.0662V39Z" }))));
};
exports.default = ThirdPlace;
